import path from 'node:path'
import * as p from '@clack/prompts'
import { findConfigFile } from '@core-engine/config/resolver.js'
import type { Command } from 'commander'

const INIT_COMMAND = 'init'

interface CommandOptions {
  cwd?: unknown
}

function resolveCommandCwd(command: Command): string {
  const options = command.opts<CommandOptions>()
  return typeof options.cwd === 'string' ? path.resolve(options.cwd) : process.cwd()
}

export function requireInitializedProject(command: Command): void {
  if (command.name() === INIT_COMMAND) {
    return
  }

  const cwd = resolveCommandCwd(command)
  if (findConfigFile(cwd)) {
    return
  }

  p.log.error("Couldn't find betterstart project. Please run `betterstart init` first.")
  process.exit(1)
}
